// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.custom-checkbox {
    /* Match the text input's height (adjust if needed) */
    height: calc(1.5em + 0.75rem + 2px);
    /* Make the width equal to the height */
    aspect-ratio: 1 / 1;
    /* Optionally remove default styling for a more consistent look */
    appearance: none;
    background-color: #ff746c;
    border: 1px solid #ff746c;
    border-radius: 0.25rem;
    /* Center the check indicator if you add a background image or content */
    display: flex;
    align-items: center;
    justify-content: center;
  }
  
  .custom-checkbox:checked {
    background-color: #249d79;
    border-color: #249d79;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/TestYourKnowledgeItemCard/custom-checkbox.css"],"names":[],"mappings":"AAAA;IACI,qDAAqD;IACrD,mCAAmC;IACnC,uCAAuC;IACvC,mBAAmB;IACnB,iEAAiE;IAGjE,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;IACzB,sBAAsB;IACtB,wEAAwE;IACxE,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,yBAAyB;IACzB,qBAAqB;EACvB","sourcesContent":[".custom-checkbox {\n    /* Match the text input's height (adjust if needed) */\n    height: calc(1.5em + 0.75rem + 2px);\n    /* Make the width equal to the height */\n    aspect-ratio: 1 / 1;\n    /* Optionally remove default styling for a more consistent look */\n    -webkit-appearance: none;\n    -moz-appearance: none;\n    appearance: none;\n    background-color: #ff746c;\n    border: 1px solid #ff746c;\n    border-radius: 0.25rem;\n    /* Center the check indicator if you add a background image or content */\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .custom-checkbox:checked {\n    background-color: #249d79;\n    border-color: #249d79;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
